





import { defineComponent } from '@vue/composition-api';

import PanelWithAgendaEditor from '@/components/Live/PanelWithAgendaEditor.vue';

const Edit = defineComponent({
  components: {
    PanelWithAgendaEditor,
  },
  // setup() {},
});

export default Edit;
